__turbopack_context__.v({
  "container": "UPR1NG_container",
  "title": "UPR1NG_title",
});
